var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOphosWork = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "420px",
    height: "466px",
    viewBox: "0 0 420 466",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "work",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-417.000000, -1893.000000)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(412.000000, 1893.891173)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#CF2629",
    fillRule: "nonzero",
    points: "216.89 208.031705 224.71 207.767582 209.6 214.576094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.22,325.537243 L277.76,309.367025 L305.76,237.222225 L312.12,209.831657 L116.61,209.831657 L122.97,237.222225 L150.97,309.367025 L153.51,325.537243 L159.87,367.826324 L173.22,410.741475 L169.38,446.153567 L148.38,452.375139 C141.38,462.323785 152.19,463.566143 152.19,463.566143 L182.07,458.586929 L180.19,446.153567 L187.5,419.408634 L180.19,411.318634 L192.51,374.625054 L204.69,360.538476 C204.695472,359.427757 205.614568,358.528666 206.75,358.523313 L220.93,358.523313 C222.065432,358.528666 222.984528,359.427757 222.99,360.538476 L234.3,374.625054 L246.62,411.318634 L239.31,419.408634 L246.62,446.153567 L246.9,446.153567 L245,458.63584 L274.88,463.615054 C274.88,463.615054 285.69,462.372696 278.69,452.424051 L257.69,446.202479 L257.41,446.202479 L253.6,410.751258 L267,367.826324 L275.22,325.537243 Z",
    id: "Path",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#212226",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#212226",
    fillRule: "nonzero",
    points: "311.59 176.884716 298.81 176.884716 211.18 204.128549 130 176.884716 117.22 176.884716 116.61 209.851221 122.97 237.222225 150.95 309.367025 213.24 348.183374 277.86 309.367025 305.84 237.222225 312.2 209.851221"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#212226",
    fillRule: "nonzero",
    cx: 134.55,
    cy: 111.26474,
    rx: 18.38,
    ry: 37.6620314
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#212226",
    fillRule: "nonzero",
    cx: 293.29,
    cy: 111.26474,
    rx: 18.38,
    ry: 37.6620314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.91,107.117025 C287,169.919686 276.34,238.914571 214,239.550423 C160.91,240.098235 142,166.055659 125.09,107.117025 C108.93,50.6435429 164.89,0.929661427 214,0.929661427 C263.11,0.929661427 317.37,50.2033374 302.91,107.117025 Z",
    id: "Path",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#141415",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.71,128.383845 C268.71,178.86075 260.71,234.307086 213.95,234.82555 C174.09,235.265756 159.85,175.749964 147.19,128.383845 C135.05,82.9937606 177.08,43.0426602 213.95,43.0426602 C250.82,43.0426602 291.56,82.6318138 280.71,128.383845 Z",
    id: "Path",
    fill: "#2D2D33",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.38,52.032636 C173.8,37.8677993 193.13,29.1810762 214.38,29.1810762 C235.63,29.1810762 254.99,37.8580169 269.38,52.032636 L283,52.032636 C268.76,24.6420677 243.36,6.40777509 214.39,6.40777509 C185.42,6.40777509 160,24.6518501 145.79,52.032636 L159.38,52.032636 Z",
    id: "Path",
    fill: "#1C566D",
    fillRule: "nonzero",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#212226",
    fillRule: "nonzero",
    points: "362.35 249.342551 396.95 233.446239 400.47 247.33717 360.03 270.589807"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#212226",
    fillRule: "nonzero",
    transform: "translate(409.201951, 234.786696) rotate(-15.160000) translate(-409.201951, -234.786696) ",
    cx: 409.201951,
    cy: 234.786696,
    rx: 14.0894325,
    ry: 19.5554306
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#212226",
    fillRule: "nonzero",
    points: "295.86 207.728452 303.04 193.553833 321.76 160.000387 357.06 220.954184 381.23 237.134184 344.57 279.178706 335.39 275.989661"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#212226",
    fillRule: "nonzero",
    points: "68.06 249.342551 33.46 233.446239 29.95 247.33717 70.38 270.589807"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#212226",
    fillRule: "nonzero",
    transform: "translate(21.667298, 234.831354) rotate(-63.540000) translate(-21.667298, -234.831354) ",
    cx: 21.6672983,
    cy: 234.831354,
    rx: 19.6122043,
    ry: 14.050119
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#212226",
    fillRule: "nonzero",
    points: "134.55 207.728452 127.37 193.553833 108.65 160.000387 73.36 220.954184 49.18 237.134184 85.85 279.178706 95.02 275.989661"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#212226",
    fillRule: "nonzero",
    points: "165.66 392.184365 161.22 408.833918 168.24 421.06185 184.86 427.195381 187.5 419.457545 184.34 397.144015"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#0091CB",
    strokeWidth: 2,
    fill: "#212226",
    fillRule: "nonzero",
    points: "260.75 392.184365 265.2 408.833918 258.18 421.06185 241.56 427.195381 238.92 419.457545 242.08 397.144015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.87,77.9851995 L145.05,105.55185 C145.05,105.55185 179.26,83.4046191 187.5,98.1759613 C187.5,98.1759613 204.5,142.088912 179.18,214.585877",
    id: "Path",
    stroke: "#0091CB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.43,77.9851995 L282.25,105.55185 C282.25,105.55185 248,83.4144015 239.8,98.1759613 C239.8,98.1759613 222.8,142.088912 248.12,214.585877",
    id: "Path",
    stroke: "#0091CB",
    strokeWidth: 2
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOphosWork, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ophos-work.debe5c10.svg";
export { ForwardRef as ReactComponent };